import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOpenTalentsIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 841.89 595.28'
		width='1em'
		height='1em'
		className='svg-icon'
		{...props}>
		<path
			d='M466.67 49.38c-15.14 5.53-27.06 13.85-34.95 24.5-16.21 21.94-19.61 44.34-11.52 73.1 1.07 3.63-5.96 11.72-38.35 43.7-21.74 21.53-40.28 39.21-41.14 39.21s-8.09-1.93-16.21-4.06c-12.58-3.63-16.41-3.83-28.13-1.93-34.32 5.96-57.32 28.36-62.65 61.18-5.12 32.19 11.95 63.71 42.2 77.99 13.65 6.59 35.15 7.89 52.22 3.4l13.21-3.4 40.91 40.07 40.71 39.85-3.4 6.39c-5.76 10.02-4.9 43.9 1.07 56.92 6.39 14.08 21.74 29.62 36.22 36.88 11.08 5.53 14.71 6.19 32.62 6.39 17.91 0 21.74-.63 32.39-5.96 15.78-7.66 31.96-25.36 37.94-41.57 3.83-9.82 4.46-15.34 3.83-29.19-1.5-28.56-16.41-50.93-41.34-63.08l-13.65-6.39V193.67l10.45-3.83c14.91-5.33 30.69-20.24 39.01-37.28 6.39-12.78 7.03-15.98 7.03-32.39 0-22.17-6.19-37.28-21.31-52.22-19.61-19.81-52-27.49-77.16-18.54l-.03-.03Zm-5.32 140.04 8.95 3.83v210.14l-10.02 4.46-10.02 4.46-39.85-39.85-39.85-39.85 4.46-9.82c5.76-12.58 6.19-37.51.86-51.36l-3.63-9.59 39.01-39.01c21.31-21.31 39.21-38.58 39.85-38.15s5.12 2.56 10.22 4.69v.03Z'
			style={{
				fill: '#5d5aa4',
				fillRule: 'evenodd',
			}}
		/>
	</svg>
);
export default SvgOpenTalentsIcon;
